import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class PropertyData {
    @JsonProperty("name")
    name: string;

    @JsonProperty("multilingual")
    isMultilingual: boolean;

    @JsonProperty("multivalue")
    isMultiValue: boolean;

    @JsonProperty("datasource")
    hasDataSource: boolean;

    @JsonProperty("type")
    dataType: string;

    constructor(init?: Partial<PropertyData>) {
        Object.assign(this, init);
    }
}
